import { formatCurrencyForDisplay } from '@utils'
import { useCurrencies } from 'mmfintech-backend-api'
import { formatFloat, getCurrencySymbol, tr } from 'mmfintech-commons'

import './ExchangeMin.scss'

interface ExchangeMinProps {
  amount: number
  currencyCode: string
  dataTest?: string
}

export const ExchangeMin = ({ amount, currencyCode, dataTest }: ExchangeMinProps) => {
  const { getCurrencyPrecision } = useCurrencies()

  return (
    <div className='exchange-min' data-test={dataTest}>
      <span className='exchange-min-label'>{tr('FRONTEND.MONEY_INPUT.LABEL_MIN', 'Min')}</span>
      <span className='exchange-min-value'>
        {`${getCurrencySymbol(formatCurrencyForDisplay(currencyCode))} ${formatFloat(amount, getCurrencyPrecision(currencyCode))}`}
      </span>
    </div>
  )
}
